export const DEFAULT_PAGE_STYLE = "enterprise_blue";

export const SECURITY_BLUE_ORGANIZATION_TITLE = "中国融通商业服务集团有限公司";

export const MOBILE_PAGE_STYLE_OPTIONS = [
  { label: "企业蓝", value: "enterprise_blue" },
  { label: "军队绿", value: "army_green" },
  { label: "公务员红", value: "civil_servant_red" },
  { label: "学院蓝", value: "academy_blue" },
  { label: "警卫蓝", value: "security_blue" },
];

const MOBILE_PAGE_STYLE_TITLES = {
  enterprise_blue: "企事业人才招聘心理测试系统",
  army_green: "心理健康测试系统",
  civil_servant_red: "公务员招录心理评估系统",
  academy_blue: "学生心理健康测试系统",
  security_blue: "警卫安保职业素养心理测评系统",
};

const MOBILE_PAGE_STYLE_VARS = {
  enterprise_blue: {
    "--mobile-primary": "#0055FF",
    "--mobile-primary-dark": "#003399",
    "--mobile-primary-light": "#3380FF",
    "--mobile-primary-soft": "#E6F0FF",
    "--mobile-accent": "#BF943F",
    "--mobile-bg": "#F8FAFC",
    "--mobile-bg-accent": "#F5F9FF",
    "--mobile-card-bg": "#FFFFFF",
    "--mobile-border": "#C7DFFF",
    "--mobile-text": "#1E293B",
    "--mobile-text-muted": "#64748B",
  },
  army_green: {
    "--mobile-primary": "#2E5528",
    "--mobile-primary-dark": "#1F3C1A",
    "--mobile-primary-light": "#6FA467",
    "--mobile-primary-soft": "#E1EDE0",
    "--mobile-bg": "#F8FAF7",
    "--mobile-bg-accent": "#F3F6F2",
    "--mobile-card-bg": "#FAFDF9",
    "--mobile-border": "#C5DCC1",
    "--mobile-text": "#1F3C1A",
    "--mobile-text-muted": "#52624E",
  },
  civil_servant_red: {
    "--mobile-primary": "#B23D3D",
    "--mobile-primary-dark": "#752525",
    "--mobile-primary-light": "#E17B7B",
    "--mobile-primary-soft": "#F7D2D2",
    "--mobile-accent": "#BF943F",
    "--mobile-bg": "#FDFDFD",
    "--mobile-bg-accent": "#FDF3F1",
    "--mobile-card-bg": "#FFFFFF",
    "--mobile-border": "#F3DEDC",
    "--mobile-text": "#3B1D1D",
    "--mobile-text-muted": "#725555",
  },
  academy_blue: {
    "--mobile-primary": "#0284C7",
    "--mobile-primary-dark": "#0B527A",
    "--mobile-primary-light": "#0EA5E9",
    "--mobile-primary-soft": "#E0F2FE",
    "--mobile-accent": "#F59E0B",
    "--mobile-bg": "#F8FAFC",
    "--mobile-bg-accent": "#F0F9FF",
    "--mobile-card-bg": "#FFFFFF",
    "--mobile-border": "#BAE6FD",
    "--mobile-text": "#1E293B",
    "--mobile-text-muted": "#64748B",
  },
  security_blue: {
    "--mobile-primary": "#0A3164",
    "--mobile-primary-dark": "#06234A",
    "--mobile-primary-light": "#315A8D",
    "--mobile-primary-soft": "#E6F0FF",
    "--mobile-accent": "#C9880B",
    "--mobile-bg": "#F8FAFC",
    "--mobile-bg-accent": "#F5F9FF",
    "--mobile-card-bg": "#FFFFFF",
    "--mobile-border": "#E2E8F0",
    "--mobile-text": "#1E293B",
    "--mobile-text-muted": "#64748B",
  },
};

export const normalizePageStyle = (pageStyle) => {
  const normalized = String(pageStyle || "").trim();
  return MOBILE_PAGE_STYLE_OPTIONS.some((option) => option.value === normalized)
    ? normalized
    : DEFAULT_PAGE_STYLE;
};

export const getMobilePageStyleVars = (pageStyle) => {
  return MOBILE_PAGE_STYLE_VARS[normalizePageStyle(pageStyle)];
};

export const getMobilePageStyleTitle = (pageStyle) => {
  return MOBILE_PAGE_STYLE_TITLES[normalizePageStyle(pageStyle)];
};

export const applyMobilePageStyle = (pageStyle) => {
  const normalized = normalizePageStyle(pageStyle);
  if (typeof document !== "undefined") {
    document.documentElement.dataset.pageStyle = normalized;
    document.title = getMobilePageStyleTitle(normalized);
    Object.entries(getMobilePageStyleVars(normalized)).forEach(([key, value]) => {
      document.documentElement.style.setProperty(key, value);
    });
  }
  return normalized;
};
